var map = {
	"./symbol_0.png": "77bd",
	"./symbol_1.png": "ed61",
	"./symbol_2.png": "434d",
	"./symbol_3.png": "8107",
	"./symbol_4.png": "0543",
	"./symbol_5.png": "4d9d",
	"./symbol_6.png": "143c",
	"./symbol_7.png": "a65a",
	"./symbol_8.png": "3048"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "03a9";